import { ElementRef, EventEmitter, Injectable } from '@angular/core';
import { NgControl } from '@angular/forms';
import { TimeoutService } from '@df/ng/timeout.service';
import { BehaviorSubject } from 'rxjs';

let uid = 0;

export interface IControlItem {
    ngControl: NgControl;
    inputRef: ElementRef;
}

@Injectable()
export class ICmsFormFieldModel {
    /**
     * Registered items set
     */
    private items: IControlItem[] = [];

    readonly uid = uid++;

    /**
     * Items change notification
     */
    readonly itemsChange = new BehaviorSubject<IControlItem | undefined>(undefined);
    /**
     * Params like rquried change notifiction
     */
    readonly paramsChange = new EventEmitter<void>();

    constructor(private timeoutService: TimeoutService) {}

    register(item: IControlItem): () => void {
        this.items.push(item);
        this.notifyChange();
        return () => this.unregister(item);
    }

    unregister(item: IControlItem): void {
        const index = this.items.indexOf(item);
        if (index > -1) {
            this.items.splice(index, 0);
            this.notifyChange();
        }
    }

    private notifyChange(): void {
        this.itemsChange.next(this.items[0]);
    }

    notifyParamsChange(): void {
        this.timeoutService.setTimeout(() => {
            this.paramsChange.emit();
        });
    }

    get item() {
        return this.items[0];
    }
}
